import { JsonConvert, ValueCheckingMode } from 'json2typescript';
import { QRReq, QRReq552, RequestRoot, _FullName, _Person, _PersonIdentity } from 'types';
import { RequestFeatures } from '../features';
import { RequestFeaturesV2 } from '../features2';
import { RequestToQrCodeStringConverter1 } from './qr-code.converter1';
import { RequestToQrCodeStringConverter2 } from './qr-code.converter2';

export class DepartmentInfo {
    city: string;
    country: string;
}

export class VersionInfo {
    website: string;
}

export class RequestToQrCodeStringConverter {
    toString(req: RequestRoot, department: DepartmentInfo, version: VersionInfo): string {
        const qrReq = this.toQRReq(req, department, version);
        const converter = new JsonConvert();
        converter.valueCheckingMode = ValueCheckingMode.ALLOW_NULL;
        converter.ignoreRequiredCheck = true;
        const res = JSON.stringify(converter.serializeObject(qrReq));
        return res;
    }

    toInetString(req: RequestRoot): string {
        const qrReq: any = {};
        if (req.features instanceof RequestFeatures) {
            const f = req.features as RequestFeatures;
            qrReq['1'] = f.applicant.personIdentity.fullName.firstName;
            qrReq['2'] = f.applicant.personIdentity.fullName.lastName;
            qrReq['3'] = f.applicant.personIdentity.fullName.middleName.value || '';
            qrReq['4'] = f.applicant.personIdentity.birthDate.value.replace('-00-00', '-01-01');
            qrReq['5'] = req.uid;
        }
        if (req.features instanceof RequestFeaturesV2) {
            const f = req.features as RequestFeaturesV2;
            qrReq['1'] = f.applicant.personIdentity.fullName.firstName;
            qrReq['2'] = f.applicant.personIdentity.fullName.lastName;
            qrReq['3'] = f.applicant.personIdentity.fullName.middleName.value || '';
            qrReq['4'] = f.applicant.personIdentity.birthDate.value.replace('-00-00', '-01-01');
            qrReq['5'] = req.uid;
        }
        const res = JSON.stringify(qrReq);
        return res;
    }

    private toQRReq(request: RequestRoot, department: DepartmentInfo, version: VersionInfo): QRReq | QRReq552 {
        const events = request.eventHistory!.filter(e => e.type === 'READY');
        const aDate = events.length ? events[0].created!.toISOString().substr(0, 10) : undefined;
        if (request.features instanceof RequestFeatures) {
            return (new RequestToQrCodeStringConverter1()).toQRReq(request.features, department, version, aDate);
        }
        if (request.features instanceof RequestFeaturesV2) {
            return (new RequestToQrCodeStringConverter2()).toQRReq(request.features, department, version, aDate);
        }
        throw new Error();
    }
}
